import React, {useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import VS from "constants/ValidationShema";
import InputLimits from "constants/InputLimits";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import {withRouter} from "react-router";
import AddThreadAsSupplierForm from "./AddThreadAsSupplierForm";
import CorrespondenceService from "services/CorrespondenceService";
import isResponseValid from "libs/isResponseValid";


const limits = InputLimits.procedure.correspondence;

function AddThreadAsSupplierPopup(
    {
        match,
        rfxRoundId,
        listResourceId,
        onClose = () => {
        },
        formSubmit,
    }) {

    let demandId = match.params.id;

    const [error, setError] = useState('');
    const [working, setWorking] = useState(false);
    const formId = useId();

    const handleSubmit = () => {
        setError('');
        formSubmit[formId]();
    }

    const handleSaveResponse = (response) => {
        if (isResponseValid(response, setError)) {
            setWorking(false);
            onClose(response);
        } else {
            setWorking(false);
        }
    }

    const onSubmit = (thread) => {
        setWorking(true);

        let sender;
        if (thread.suggestContractor) {
            sender = {
                name: thread.name,
                email: thread.email,
                vatin: {...thread.vatin},
            }
        } else {
            sender = {
                contractorDepartmentId: thread.contractorDepartmentId
            }
        }

        const req = {
            subject: thread.subject,
            message: {
                attachments: thread.attachments,
                contents: thread.contents,
                sender
            }
        }

        CorrespondenceService.saveBuyerThreadAsContractor(rfxRoundId, req, listResourceId).then(handleSaveResponse).catch(() => setWorking(false));
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working));
        buttons.push(createButton(Tr('save'), handleSubmit, undefined, working));
        return buttons;
    }


    return (
        <Dialog
            title={Tr("new_message")}
            open={true}
            maxWidth='md'
            dialogActions={<MultiButton buttons={getButtons()} />}
        >
            <Form
                initialValues={{
                    suggestContractor: false,
                    contractorName: '',
                    contractorDepartmentId: 0,
                    name: '',
                    email: '',
                    vatin: {
                        number: "",
                        prefix: "PL",
                    },
                    subject: "",
                    contents: "",
                    attachments: []
                }}
                validationSchema={Yup.object().shape({
                    contractorName: VS.string(),
                    subject: VS.stringMax(limits.SUBJECT),
                    contents: VS.string(),
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <AddThreadAsSupplierForm formikProps={formikProps} error={error} demandId={demandId} working={working}/>
                )}
            </Form>
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(withRouter(AddThreadAsSupplierPopup));